import React from "react";

export default function ContactForm() {
  const handleSubmit = (e) => {
    e.preventDefault();

    // TODO: send data via API (fetch / axios)
    // Example:
    // fetch("/api/contact", { method: "POST", body: JSON.stringify(formData) })

    alert("Form submitted (demo)");
  };

  return (
    <div className="contact-us">
      <div className="container">
        <div className="row align-items-center">

          {/* Left Content */}
          <div className="col-lg-6">
            <div className="contact-details">

              <div className="section-title">
                <h3 className="wow fadeInUp">Contact Us</h3>
                <h2
                  className="text-anime-style-3"
                  style={{ perspective: "400px" }}
                >
                  Get in touch with us today
                </h2>
              </div>

              <div className="contact-detail-body">
                <p
                  className="wow fadeInUp"
                  data-wow-delay="0.25s"
                >
                  Need software solutions or support? Contact our
                  development team anytime via email or phone.
                </p>

                <h3
                  className="wow fadeInUp"
                  data-wow-delay="0.5s"
                >
                  Follow us:
                </h3>

                <ul
                  className="wow fadeInUp"
                  data-wow-delay="0.75s"
                >
                  <li>
                    <a
                      href="https://facebook.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Facebook"
                    >
                      <i className="fa-brands fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://instagram.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Instagram"
                    >
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://linkedin.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="LinkedIn"
                    >
                      <i className="fa-brands fa-linkedin-in"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://twitter.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Twitter"
                    >
                      <i className="fa-brands fa-twitter"></i>
                    </a>
                  </li>
                </ul>
              </div>

            </div>
          </div>

          {/* Right Form */}
          <div className="col-lg-6">
            <div
              className="contact-form-box wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="contact-form">
                <form onSubmit={handleSubmit} noValidate>
                  <div className="row">

                    <div className="form-group col-md-6 mb-4">
                      <label htmlFor="fname">Full Name</label>
                      <input
                        type="text"
                        id="fname"
                        name="name"
                        className="form-control"
                        placeholder="Enter full name"
                        required
                      />
                    </div>

                    <div className="form-group col-md-6 mb-4">
                      <label htmlFor="phone">Phone</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        className="form-control"
                        placeholder="Enter phone"
                        required
                      />
                    </div>

                    <div className="form-group col-md-6 mb-4">
                      <label htmlFor="email">Email</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Enter email"
                        required
                      />
                    </div>

                    <div className="form-group col-md-12 mb-4">
                      <label htmlFor="msg">Message</label>
                      <textarea
                        id="msg"
                        name="message"
                        className="form-control"
                        rows="7"
                        placeholder="Enter your message"
                        required
                      ></textarea>
                    </div>

                    <div className="col-md-12">
                      <button type="submit" className="btn-default">
                        Send a Message
                      </button>
                    </div>

                  </div>
                </form>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
